import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import AppLocale from '../lang';
import AppConfig from './AppConfig';
import {config} from './index';

const i18nProvider = i18n
    .use(initReactI18next)
    .init({
        fallbackLng: false,
        lng: AppConfig.locale.locale,
        debug: config.isLocalhost,
        interpolation: {
            escapeValue: false // not needed for react as it escapes by default
        },
        resources: AppLocale
    });

export default i18nProvider;